const BLUE_S100 = '#1CA8DD';
const GREEN_S100 = '#86B62C';
const DARK_BLACK_S20 = '#D2D3D4';
const RED_S100 = '#D75645';
const GRAY_S80 = '#6F8990';
const GRAY_S20 = '#C5D0D3';
const BLUE_S50 = '#8DD3EE';

export const PROGRESS_TRAIL_COLOR = '#E9E9EA';
export const PROGRESS_STROKE_COLOR = '#84BD60';

const donutColorMap = {
    BLUE_S50,
    BLUE_S100,
    GREEN_S100,
    GRAY_S20,
    GRAY_S80,
};

const domainsColorMap = {
    entities: BLUE_S100,
    dataProducts: GREEN_S100,
};

const governanceStatusColorMap = {
    Draft: DARK_BLACK_S20,
    Review: BLUE_S100,
    Certified: GREEN_S100,
};

const dataQualityColorMap = {
    Passed: GREEN_S100,
    Failed: RED_S100,
};

export const colorUtilService = {
    donutColorMap,
    domainsColorMap,
    dataQualityColorMap,
    governanceStatusColorMap,
};
